

import React, { memo } from 'react';
import { ErrorIcon, Text } from '../../../ui-kit';
import '../styles/_warning.scss';





function Warning({ text }) {
  return (
    <div className="delete-confirmation-warning">
      <ErrorIcon size={20} />
      <Text noMargin label>{text}</Text>
    </div>);

}

export default memo(Warning);